import { Modal } from "react-bootstrap";
import React from "react";
import { useTranslation } from 'react-i18next';

const GenericModal = ({ id, handleClose = () => { }, show, showHeader = true, showFooter = false, children, lang = '' }) => {

  const { i18n,t } = useTranslation();

  return (
    <Modal show={show} onHide={handleClose} id={id} className={"generic_modal"} data-lang={i18n.language} centered>
      {showHeader &&
        <Modal.Header>
          <button onClick={handleClose}>{t('modal_fermer')}</button>
        </Modal.Header>
      }
      <Modal.Body>{children}</Modal.Body>
      {showFooter &&
        <div className={"cta_wrapper"}>
          <button className={"cta dark"} onClick={handleClose}>{t('modal_valider')}</button>
        </div>
      }
    </Modal>
  )
}

export default GenericModal
